// Module
var code = `<div class="show-lesson" lang="{{::playerViewModel.lesson.locale}}" dir="{{::playerViewModel.lesson.localeDirection}}"><div observe="::playerViewModel.id" dynamic-node="::playerViewModel.lesson.showDirectiveName" player-view-model="::playerViewModel" ng-class="::['show_lesson', 'content', playerViewModel.lesson.lesson_type]"></div></div>`;
// Exports
export default code;